import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An extended ISO 8601 date string in the format YYYY-MM-DD */
  AWSDate: any;
  /** An extended ISO 8601 date and time string in the format YYYY-MM-DDThh:mm:ss.sssZ */
  AWSDateTime: any;
  /** An email address in the format local-part@domain-part as defined by RFC 822 */
  AWSEmail: any;
  /**
   * A valid IPv4 or IPv6 address. IPv4 addresses are expected in quad-dotted notation (123.12.34.56).
   * IPv6 addresses are expected in non-bracketed, colon-separated format (1a2b:3c4b::1234:4567). You can
   * include an optional CIDR suffix (123.45.67.89/16) to indicate subnet mask.
   */
  AWSIPAddress: any;
  /**
   * A JSON string. Any valid JSON construct is automatically parsed and loaded in the resolver
   * mapping templates as maps, lists, or scalar values rather than as the literal input strings.
   * Unquoted strings or otherwise invalid JSON result in a GraphQL validation error.
   */
  AWSJSON: any;
  /**
   * A phone number. This value is stored as a string. Phone numbers can contain either spaces or
   * hyphens to separate digit groups. Phone numbers without a country code are assumed to be US/North
   * American numbers adhering to the North American Numbering Plan (NANP).
   */
  AWSPhone: any;
  /** An extended ISO 8601 time string in the format hh:mm:ss.sss */
  AWSTime: any;
  /** An integer value representing the number of seconds before or after 1970-01-01-T00:00Z */
  AWSTimestamp: any;
  /**
   * A URL as defined by RFC 1738. For example, https://www.amazon.com/dp/B000NZW3KC/ or
   * mailto:example@example.com. URLs must contain a schema (http, mailto) and can't contain two forward
   * slashes (//) in the path part.
   */
  AWSURL: any;
};










export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  address4?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type Agent = {
  __typename?: 'Agent';
  agentId: Scalars['String'];
  instanceId: Scalars['String'];
  status: AgentStatus;
  statusName: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  queues: Array<Queue>;
  quickConnectId?: Maybe<Scalars['String']>;
  hierarchyGroupId?: Maybe<Scalars['String']>;
  routingProfileId: Scalars['String'];
  routingProfileName: Scalars['String'];
};

export type AgentInput = {
  agentId: Scalars['String'];
  instanceId: Scalars['String'];
  status: Scalars['String'];
  statusName: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  hierarchyGroupId?: Maybe<Scalars['String']>;
  routingProfileId?: Maybe<Scalars['String']>;
  routingProfileName?: Maybe<Scalars['String']>;
  quickConnectId?: Maybe<Scalars['String']>;
  outboundNumber?: Maybe<Scalars['String']>;
};

export enum AgentStatus {
  /** Verfuegbar (Gruen) */
  Available = 'AVAILABLE',
  /** Im Gespraech (Rot) */
  OnCall = 'ON_CALL',
  /** Abwesend (Gelb) */
  Away = 'AWAY',
  /** Nicht eingeloggt (Grau) */
  Offline = 'OFFLINE',
  /** Missed oder Error */
  Missed = 'MISSED',
  /** ACW */
  Acw = 'ACW',
  /** CALLBACK */
  Callback = 'CALLBACK'
}

export type CallEntry = {
  __typename?: 'CallEntry';
  contactId: Scalars['String'];
  instanceId: Scalars['String'];
  callStatus?: Maybe<CallStatus>;
  time: Scalars['AWSDateTime'];
  phone: Scalars['String'];
  agent?: Maybe<Agent>;
  queue: Queue;
  customer?: Maybe<Customer>;
};

export type CallEntryInput = {
  contactId: Scalars['String'];
  instanceId: Scalars['String'];
  callStatus?: Maybe<CallStatus>;
  time: Scalars['AWSDateTime'];
  phone: Scalars['String'];
  agent?: Maybe<AgentInput>;
  queue: QueueInput;
  customer?: Maybe<CustomerInput>;
  wrapUpNames?: Maybe<Array<Scalars['String']>>;
  contactWrapUpName?: Maybe<Scalars['String']>;
};

export type CallHistory = {
  __typename?: 'CallHistory';
  total: Scalars['Int'];
  history: Array<CallEntry>;
};

export enum CallRecordingAction {
  Start = 'START',
  Stop = 'STOP',
  Suspend = 'SUSPEND',
  Resume = 'RESUME'
}

export type CallRecordingInput = {
  contactId: Scalars['String'];
  initialContactId: Scalars['String'];
  action: CallRecordingAction;
  voiceRecordingTrack?: Maybe<VoiceRecordingTrack>;
};

export enum CallStatus {
  Answered = 'ANSWERED',
  Callback = 'CALLBACK',
  Missed = 'MISSED',
  Voicemail = 'VOICEMAIL',
  Outbound = 'OUTBOUND',
  Transfer = 'TRANSFER'
}

export type ConnectCredentialsResponse = {
  __typename?: 'ConnectCredentialsResponse';
  credentials: Scalars['String'];
  destination: Scalars['String'];
};

export type Contact = {
  __typename?: 'Contact';
  mail?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
};

export type CostCenter = {
  __typename?: 'CostCenter';
  code?: Maybe<Scalars['String']>;
  accountingArea?: Maybe<Scalars['String']>;
};

export type CurrentMetric = {
  __typename?: 'CurrentMetric';
  metric: MetricType;
  value: Scalars['Float'];
};

export type CurrentQueueMetric = {
  __typename?: 'CurrentQueueMetric';
  queue: Queue;
  metrics: Array<CurrentMetric>;
};

export type Customer = {
  __typename?: 'Customer';
  accountNumber?: Maybe<Scalars['String']>;
  additionalInformation?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  attributes?: Maybe<Array<CustomerAttribute>>;
  billingAddress?: Maybe<Address>;
  birthDate?: Maybe<Scalars['String']>;
  businessEmailAddress?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  businessPhoneNumber?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  homePhoneNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<Address>;
  middleName?: Maybe<Scalars['String']>;
  mobilePhoneNumber?: Maybe<Scalars['String']>;
  partyType?: Maybe<Scalars['String']>;
  personalEmailAddress?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<Address>;
};

export type CustomerAttribute = {
  __typename?: 'CustomerAttribute';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type CustomerInput = {
  id: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  company: Scalars['String'];
  street: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  deeplink: Scalars['AWSURL'];
  source: Scalars['String'];
};

export type Department = {
  __typename?: 'Department';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  companyCode?: Maybe<Scalars['String']>;
  hierarchy?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Location = {
  __typename?: 'Location';
  street?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['Int']>;
  houseNumberAddition?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  office?: Maybe<Scalars['String']>;
};

export enum MetricType {
  /** Aktuelle Anzahl der eingeloggten Agents - Current */
  AgentsOnline = 'AGENTS_ONLINE',
  /** Aktuelle Anzahl der verfuegbaren Agents - Current */
  AgentsAvailable = 'AGENTS_AVAILABLE',
  /** Quote fuer SL 30 - Historic */
  ServiceLevel = 'SERVICE_LEVEL',
  /** Anrufe in der Queue */
  ContactsInQueue = 'CONTACTS_IN_QUEUE',
  /** Gesamtanzahl Anrufe am Tag - Custom (CONTACTS_HANDLED + CONTACTS_ABANDONED - CONTACTS_OUTBOUND) */
  ContactsIncoming = 'CONTACTS_INCOMING',
  /** Annahmequote der Anrufe am Tag - Custom (MAX(CONTACTS_HANDLED, 0) / MAX(MAX(CONTACTS_HANDLED + CONTACTS_ABANDONED, CONTACTS_QUEUED), 1) */
  HandledQuota = 'HANDLED_QUOTA',
  /** Durchschnittliche Wartezeit der Anrufer am Tag - Custom */
  QueueAnswerTime = 'QUEUE_ANSWER_TIME'
}

export type Mutation = {
  __typename?: 'Mutation';
  addCall: CallEntry;
  setNotifications: Array<Notification>;
  updateMetrics: Array<CurrentQueueMetric>;
  updateAgent?: Maybe<Agent>;
  setOutboundNumber: Scalars['Boolean'];
  setWrapUpReasons: Scalars['Boolean'];
  setCallRecording: Scalars['Boolean'];
  setCallRecordingCategory: Scalars['Boolean'];
  setRoutingProfile: Scalars['Boolean'];
};


export type MutationAddCallArgs = {
  callEntry: CallEntryInput;
};


export type MutationSetNotificationsArgs = {
  notifications: Array<NotificationInput>;
};


export type MutationUpdateMetricsArgs = {
  instanceId: Scalars['String'];
};


export type MutationUpdateAgentArgs = {
  agentEntry: AgentInput;
};


export type MutationSetOutboundNumberArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationSetWrapUpReasonsArgs = {
  contactId: Scalars['String'];
  originalContactId: Scalars['String'];
  wrapUpNames: Array<Scalars['String']>;
};


export type MutationSetCallRecordingArgs = {
  callRecordingEntry?: Maybe<CallRecordingInput>;
};


export type MutationSetCallRecordingCategoryArgs = {
  contactId: Scalars['String'];
  category: Scalars['String'];
};


export type MutationSetRoutingProfileArgs = {
  routingProfile: RoutingProfileInput;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['String'];
  agentId: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  timestamp: Scalars['AWSDateTime'];
  notificationType: NotificationType;
  payload: Scalars['String'];
  state: NotificationState;
};

export type NotificationInput = {
  id: Scalars['String'];
  agentId: Scalars['String'];
  timestamp: Scalars['AWSDateTime'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  notificationType: NotificationType;
  payload: Scalars['String'];
  state: NotificationState;
};

export enum NotificationState {
  Unread = 'UNREAD',
  Read = 'READ',
  Hidden = 'HIDDEN'
}

export enum NotificationType {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  phoneNumber: Scalars['String'];
  instanceId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type PhonebookUser = {
  __typename?: 'PhonebookUser';
  username?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  personnelNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  hierarchicalLevel?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  company?: Maybe<Scalars['String']>;
  department?: Maybe<Department>;
  costCenter?: Maybe<CostCenter>;
};

export type Query = {
  __typename?: 'Query';
  getCallHistory: CallHistory;
  getAgentStatus: Array<Agent>;
  getAgentQueues: Array<Queue>;
  getCustomer: Array<Customer>;
  getAvailableOutboundNumbers: Array<PhoneNumber>;
  getConnectSSOCredentials: ConnectCredentialsResponse;
  getWrapUpTime: WrapUpTime;
  getWrapUpReasons: Array<WrapUpReason>;
  getNotifications: Array<Notification>;
  getPhoneBookEntries: Array<PhonebookUser>;
  getOutboundNumber: PhoneNumber;
  getRoutingProfile: RoutingProfile;
  getRoutingProfiles: Array<Maybe<RoutingProfile>>;
};


export type QueryGetCallHistoryArgs = {
  options: QueryCallHistoryOptionsInput;
};


export type QueryGetAgentStatusArgs = {
  instanceId: Scalars['String'];
  queueId?: Maybe<Scalars['String']>;
};


export type QueryGetAgentQueuesArgs = {
  instanceId: Scalars['String'];
};


export type QueryGetCustomerArgs = {
  search: Scalars['String'];
};


export type QueryGetConnectSsoCredentialsArgs = {
  instanceId: Scalars['String'];
  jwtToken: Scalars['String'];
};


export type QueryGetWrapUpReasonsArgs = {
  queueId?: Maybe<Scalars['String']>;
  matching?: Maybe<WrapUpMatching>;
};


export type QueryGetPhoneBookEntriesArgs = {
  search: Scalars['String'];
};


export type QueryGetRoutingProfileArgs = {
  agentId: Scalars['String'];
};


export type QueryGetRoutingProfilesArgs = {
  agentId: Scalars['String'];
};

export type QueryCallHistoryFilter = {
  field: Scalars['String'];
  operator: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type QueryCallHistoryFilterOptionsInput = {
  logic: Scalars['String'];
  filters: Array<QueryCallHistoryFilter>;
};

export type QueryCallHistoryOptionsInput = {
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  sort?: Maybe<Array<QueryCallHistorySortOptionsInput>>;
  filter?: Maybe<QueryCallHistoryFilterOptionsInput>;
};

export type QueryCallHistorySortOptionsInput = {
  field: Scalars['String'];
  dir?: Maybe<Scalars['String']>;
};

export type Queue = {
  __typename?: 'Queue';
  id: Scalars['String'];
  name: Scalars['String'];
  quickConnectId?: Maybe<Scalars['String']>;
};

export type QueueInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type RoutingProfile = {
  __typename?: 'RoutingProfile';
  routingProfileId: Scalars['String'];
  routingProfileName: Scalars['String'];
};

export type RoutingProfileInput = {
  agentId: Scalars['String'];
  routingProfileId: Scalars['String'];
  routingProfileName: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  subscribeToCallHistory?: Maybe<CallEntry>;
  subscribeToNotifications?: Maybe<Array<Notification>>;
  subscribeToMetrics?: Maybe<Array<CurrentQueueMetric>>;
  subscribeToAgentList?: Maybe<Agent>;
};

export enum VoiceRecordingTrack {
  FromAgent = 'FROM_AGENT',
  ToAgent = 'TO_AGENT',
  All = 'ALL'
}

export enum WrapUpMatching {
  Lax = 'LAX',
  Strict = 'STRICT'
}

export type WrapUpReason = {
  __typename?: 'WrapUpReason';
  id: Scalars['String'];
  name: Scalars['String'];
  queueIds: Array<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
};

export type WrapUpTime = {
  __typename?: 'WrapUpTime';
  duration: Scalars['Int'];
  expiration: Scalars['Int'];
};

export type CallHistoryQueryVariables = Exact<{
  options: QueryCallHistoryOptionsInput;
}>;


export type CallHistoryQuery = (
  { __typename?: 'Query' }
  & { getCallHistory: (
    { __typename?: 'CallHistory' }
    & Pick<CallHistory, 'total'>
    & { history: Array<(
      { __typename?: 'CallEntry' }
      & Pick<CallEntry, 'instanceId' | 'contactId' | 'callStatus' | 'time' | 'phone'>
      & { agent?: Maybe<(
        { __typename?: 'Agent' }
        & Pick<Agent, 'agentId' | 'firstName' | 'lastName'>
      )>, customer?: Maybe<(
        { __typename?: 'Customer' }
        & Pick<Customer, 'profileId' | 'firstName' | 'lastName'>
      )>, queue: (
        { __typename?: 'Queue' }
        & Pick<Queue, 'id' | 'name'>
      ) }
    )> }
  ) }
);

export type CallHistoryUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CallHistoryUpdateSubscription = (
  { __typename?: 'Subscription' }
  & { subscribeToCallHistory?: Maybe<(
    { __typename?: 'CallEntry' }
    & Pick<CallEntry, 'instanceId' | 'contactId' | 'callStatus' | 'time' | 'phone'>
    & { agent?: Maybe<(
      { __typename?: 'Agent' }
      & Pick<Agent, 'agentId' | 'firstName' | 'lastName'>
    )>, customer?: Maybe<(
      { __typename?: 'Customer' }
      & Pick<Customer, 'profileId' | 'firstName' | 'lastName'>
    )>, queue: (
      { __typename?: 'Queue' }
      & Pick<Queue, 'id' | 'name'>
    ) }
  )> }
);

export type CustomerQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type CustomerQuery = (
  { __typename?: 'Query' }
  & { getCustomer: Array<(
    { __typename?: 'Customer' }
    & Pick<Customer, 'profileId' | 'accountNumber' | 'firstName' | 'lastName' | 'middleName' | 'gender' | 'birthDate' | 'phoneNumber' | 'homePhoneNumber' | 'mobilePhoneNumber' | 'emailAddress' | 'personalEmailAddress' | 'businessName' | 'businessPhoneNumber' | 'businessEmailAddress' | 'partyType' | 'additionalInformation'>
    & { address?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'address1' | 'address2' | 'address3' | 'address4' | 'postalCode' | 'city' | 'county' | 'country' | 'province' | 'state'>
    )>, mailingAddress?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'address1' | 'address2' | 'address3' | 'address4' | 'postalCode' | 'city' | 'county' | 'country' | 'province' | 'state'>
    )>, shippingAddress?: Maybe<(
      { __typename?: 'Address' }
      & Pick<Address, 'address1' | 'address2' | 'address3' | 'address4' | 'postalCode' | 'city' | 'county' | 'country' | 'province' | 'state'>
    )>, attributes?: Maybe<Array<(
      { __typename?: 'CustomerAttribute' }
      & Pick<CustomerAttribute, 'key' | 'value'>
    )>> }
  )> }
);

export type AgentListQueryVariables = Exact<{
  instanceId: Scalars['String'];
  queueId: Scalars['String'];
}>;


export type AgentListQuery = (
  { __typename?: 'Query' }
  & { getAgentStatus: Array<(
    { __typename?: 'Agent' }
    & Pick<Agent, 'instanceId' | 'agentId' | 'firstName' | 'lastName' | 'status' | 'statusName' | 'quickConnectId'>
    & { queues: Array<(
      { __typename?: 'Queue' }
      & Pick<Queue, 'id' | 'name' | 'quickConnectId'>
    )> }
  )> }
);

export type AgentQueuesQueryVariables = Exact<{
  instanceId: Scalars['String'];
}>;


export type AgentQueuesQuery = (
  { __typename?: 'Query' }
  & { getAgentQueues: Array<(
    { __typename?: 'Queue' }
    & Pick<Queue, 'id' | 'name' | 'quickConnectId'>
  )> }
);

export type AgentListUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AgentListUpdateSubscription = (
  { __typename?: 'Subscription' }
  & { subscribeToAgentList?: Maybe<(
    { __typename?: 'Agent' }
    & Pick<Agent, 'instanceId' | 'agentId' | 'firstName' | 'lastName' | 'status' | 'statusName' | 'quickConnectId'>
    & { queues: Array<(
      { __typename?: 'Queue' }
      & Pick<Queue, 'id' | 'name' | 'quickConnectId'>
    )> }
  )> }
);

export type SetOutboundNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type SetOutboundNumberMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setOutboundNumber'>
);

export type GetAvailableOutboundNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableOutboundNumbersQuery = (
  { __typename?: 'Query' }
  & { getAvailableOutboundNumbers: Array<(
    { __typename?: 'PhoneNumber' }
    & Pick<PhoneNumber, 'instanceId' | 'phoneNumber' | 'description'>
  )> }
);

export type MetricsListSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MetricsListSubscription = (
  { __typename?: 'Subscription' }
  & { subscribeToMetrics?: Maybe<Array<(
    { __typename?: 'CurrentQueueMetric' }
    & { metrics: Array<(
      { __typename?: 'CurrentMetric' }
      & Pick<CurrentMetric, 'metric' | 'value'>
    )>, queue: (
      { __typename?: 'Queue' }
      & Pick<Queue, 'id' | 'name' | 'quickConnectId'>
    ) }
  )>> }
);

export type ConnectSsoCredentialsQueryVariables = Exact<{
  instanceId: Scalars['String'];
  jwtToken: Scalars['String'];
}>;


export type ConnectSsoCredentialsQuery = (
  { __typename?: 'Query' }
  & { getConnectSSOCredentials: (
    { __typename?: 'ConnectCredentialsResponse' }
    & Pick<ConnectCredentialsResponse, 'credentials' | 'destination'>
  ) }
);

export type WrapUpReasonsQueryVariables = Exact<{
  queueId?: Maybe<Scalars['String']>;
  matching?: Maybe<WrapUpMatching>;
}>;


export type WrapUpReasonsQuery = (
  { __typename?: 'Query' }
  & { getWrapUpReasons: Array<(
    { __typename?: 'WrapUpReason' }
    & Pick<WrapUpReason, 'id' | 'name' | 'category' | 'queueIds'>
  )> }
);

export type WrapUpTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type WrapUpTimeQuery = (
  { __typename?: 'Query' }
  & { getWrapUpTime: (
    { __typename?: 'WrapUpTime' }
    & Pick<WrapUpTime, 'duration' | 'expiration'>
  ) }
);

export type UpdateWrapUpReasonsMutationVariables = Exact<{
  contactId: Scalars['String'];
  originalContactId: Scalars['String'];
  wrapUpNames: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateWrapUpReasonsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setWrapUpReasons'>
);

export type UpdateCallRecordingCategoryMutationVariables = Exact<{
  contactId: Scalars['String'];
  category: Scalars['String'];
}>;


export type UpdateCallRecordingCategoryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setCallRecordingCategory'>
);

export type SetNotificationsMutationVariables = Exact<{
  notifications: Array<NotificationInput> | NotificationInput;
}>;


export type SetNotificationsMutation = (
  { __typename?: 'Mutation' }
  & { setNotifications: Array<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'id' | 'agentId' | 'timestamp' | 'title' | 'description' | 'notificationType' | 'payload' | 'state'>
  )> }
);

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = (
  { __typename?: 'Query' }
  & { getNotifications: Array<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'id' | 'agentId' | 'timestamp' | 'title' | 'description' | 'notificationType' | 'payload' | 'state'>
  )> }
);

export type NotificationUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationUpdateSubscription = (
  { __typename?: 'Subscription' }
  & { subscribeToNotifications?: Maybe<Array<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'id' | 'agentId' | 'timestamp' | 'title' | 'description' | 'notificationType' | 'payload' | 'state'>
  )>> }
);

export type SetCallRecordingMutationVariables = Exact<{
  callRecordingEntry?: Maybe<CallRecordingInput>;
}>;


export type SetCallRecordingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setCallRecording'>
);

export type PhoneBookEntriesQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type PhoneBookEntriesQuery = (
  { __typename?: 'Query' }
  & { getPhoneBookEntries: Array<(
    { __typename?: 'PhonebookUser' }
    & Pick<PhonebookUser, 'username' | 'title' | 'firstName' | 'lastName' | 'personnelNumber' | 'type' | 'role' | 'hierarchicalLevel' | 'company'>
    & { contact?: Maybe<(
      { __typename?: 'Contact' }
      & Pick<Contact, 'mail' | 'phone' | 'mobile' | 'fax'>
      & { location?: Maybe<(
        { __typename?: 'Location' }
        & Pick<Location, 'street' | 'houseNumber' | 'houseNumberAddition' | 'postCode' | 'city' | 'countryCode' | 'office'>
      )> }
    )>, department?: Maybe<(
      { __typename?: 'Department' }
      & Pick<Department, 'code' | 'name' | 'companyCode' | 'hierarchy'>
    )>, costCenter?: Maybe<(
      { __typename?: 'CostCenter' }
      & Pick<CostCenter, 'code' | 'accountingArea'>
    )> }
  )> }
);

export type GetRoutingProfileQueryVariables = Exact<{
  agentId: Scalars['String'];
}>;


export type GetRoutingProfileQuery = (
  { __typename?: 'Query' }
  & { getRoutingProfile: (
    { __typename?: 'RoutingProfile' }
    & Pick<RoutingProfile, 'routingProfileId' | 'routingProfileName'>
  ) }
);

export type GetRoutingProfilesQueryVariables = Exact<{
  agentId: Scalars['String'];
}>;


export type GetRoutingProfilesQuery = (
  { __typename?: 'Query' }
  & { getRoutingProfiles: Array<Maybe<(
    { __typename?: 'RoutingProfile' }
    & Pick<RoutingProfile, 'routingProfileId' | 'routingProfileName'>
  )>> }
);

export type SetRoutingProfileMutationVariables = Exact<{
  routingProfile: RoutingProfileInput;
}>;


export type SetRoutingProfileMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setRoutingProfile'>
);

export type GetOutboundNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOutboundNumberQuery = (
  { __typename?: 'Query' }
  & { getOutboundNumber: (
    { __typename?: 'PhoneNumber' }
    & Pick<PhoneNumber, 'instanceId' | 'phoneNumber'>
  ) }
);


export const CallHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CallHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryCallHistoryOptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCallHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"callStatus"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"queue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CallHistoryQuery, CallHistoryQueryVariables>;
export const CallHistoryUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CallHistoryUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToCallHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"callStatus"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"queue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CallHistoryUpdateSubscription, CallHistoryUpdateSubscriptionVariables>;
export const CustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Customer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileId"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"homePhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"personalEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"businessEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"partyType"}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"address3"}},{"kind":"Field","name":{"kind":"Name","value":"address4"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalInformation"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerQuery, CustomerQueryVariables>;
export const AgentListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AgentList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAgentStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"instanceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"queueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusName"}},{"kind":"Field","name":{"kind":"Name","value":"quickConnectId"}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quickConnectId"}}]}}]}}]}}]} as unknown as DocumentNode<AgentListQuery, AgentListQueryVariables>;
export const AgentQueuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AgentQueues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAgentQueues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"instanceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quickConnectId"}}]}}]}}]} as unknown as DocumentNode<AgentQueuesQuery, AgentQueuesQueryVariables>;
export const AgentListUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AgentListUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToAgentList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusName"}},{"kind":"Field","name":{"kind":"Name","value":"quickConnectId"}},{"kind":"Field","name":{"kind":"Name","value":"queues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quickConnectId"}}]}}]}}]}}]} as unknown as DocumentNode<AgentListUpdateSubscription, AgentListUpdateSubscriptionVariables>;
export const SetOutboundNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetOutboundNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setOutboundNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}]}}]} as unknown as DocumentNode<SetOutboundNumberMutation, SetOutboundNumberMutationVariables>;
export const GetAvailableOutboundNumbersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableOutboundNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAvailableOutboundNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetAvailableOutboundNumbersQuery, GetAvailableOutboundNumbersQueryVariables>;
export const MetricsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"MetricsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metric"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"queue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quickConnectId"}}]}}]}}]}}]} as unknown as DocumentNode<MetricsListSubscription, MetricsListSubscriptionVariables>;
export const ConnectSsoCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConnectSSOCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jwtToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getConnectSSOCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"instanceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instanceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"jwtToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jwtToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentials"}},{"kind":"Field","name":{"kind":"Name","value":"destination"}}]}}]}}]} as unknown as DocumentNode<ConnectSsoCredentialsQuery, ConnectSsoCredentialsQueryVariables>;
export const WrapUpReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WrapUpReasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matching"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WrapUpMatching"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWrapUpReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"matching"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matching"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"queueIds"}}]}}]}}]} as unknown as DocumentNode<WrapUpReasonsQuery, WrapUpReasonsQueryVariables>;
export const WrapUpTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WrapUpTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWrapUpTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"expiration"}}]}}]}}]} as unknown as DocumentNode<WrapUpTimeQuery, WrapUpTimeQueryVariables>;
export const UpdateWrapUpReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWrapUpReasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalContactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wrapUpNames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setWrapUpReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}}},{"kind":"Argument","name":{"kind":"Name","value":"originalContactId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalContactId"}}},{"kind":"Argument","name":{"kind":"Name","value":"wrapUpNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wrapUpNames"}}}]}]}}]} as unknown as DocumentNode<UpdateWrapUpReasonsMutation, UpdateWrapUpReasonsMutationVariables>;
export const UpdateCallRecordingCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCallRecordingCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCallRecordingCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}}]}]}}]} as unknown as DocumentNode<UpdateCallRecordingCategoryMutation, UpdateCallRecordingCategoryMutationVariables>;
export const SetNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notifications"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notifications"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notifications"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<SetNotificationsMutation, SetNotificationsMutationVariables>;
export const GetNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const NotificationUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"NotificationUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeToNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<NotificationUpdateSubscription, NotificationUpdateSubscriptionVariables>;
export const SetCallRecordingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCallRecording"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callRecordingEntry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCallRecording"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callRecordingEntry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callRecordingEntry"}}}]}]}}]} as unknown as DocumentNode<SetCallRecordingMutation, SetCallRecordingMutationVariables>;
export const PhoneBookEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PhoneBookEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPhoneBookEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"personnelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"hierarchicalLevel"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mail"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumberAddition"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"office"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyCode"}},{"kind":"Field","name":{"kind":"Name","value":"hierarchy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costCenter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"accountingArea"}}]}}]}}]}}]} as unknown as DocumentNode<PhoneBookEntriesQuery, PhoneBookEntriesQueryVariables>;
export const GetRoutingProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoutingProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRoutingProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"routingProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"routingProfileName"}}]}}]}}]} as unknown as DocumentNode<GetRoutingProfileQuery, GetRoutingProfileQueryVariables>;
export const GetRoutingProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRoutingProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRoutingProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"routingProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"routingProfileName"}}]}}]}}]} as unknown as DocumentNode<GetRoutingProfilesQuery, GetRoutingProfilesQueryVariables>;
export const SetRoutingProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetRoutingProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"routingProfile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoutingProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setRoutingProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"routingProfile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"routingProfile"}}}]}]}}]} as unknown as DocumentNode<SetRoutingProfileMutation, SetRoutingProfileMutationVariables>;
export const GetOutboundNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOutboundNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOutboundNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instanceId"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]} as unknown as DocumentNode<GetOutboundNumberQuery, GetOutboundNumberQueryVariables>;